import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { SpinnerService } from '@services/spinner.service';
import { ChunkedUploadService, UploadHandle } from '@services/chunked-upload.service';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import { DxFileUploaderComponent } from 'devextreme-angular/ui/file-uploader';

@Component({
    selector: 'cz-uploadPopup',
    templateUrl: './uploadPopup.component.html',
    styleUrls: ['./uploadPopup.component.css'],
    standalone: false
})
export class DocUploadPopupComponent {

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOkClose: EventEmitter<any> = new EventEmitter<any>();
  @Input() popupVisible: boolean;
  @Input() uploadContext: any;
  uploadFiles: File[];

  @ViewChild('form', { static: false }) form: DxFormComponent;
  @ViewChild('fileUploader', { static: false }) fileUploader: DxFileUploaderComponent;

  allowedFileExtensions: string[] = ['.rtf', '.txt', '.docx', '.jpg', '.jpeg', '.pdf', '.xlsx', '.msg'];
  uploadFileName: string = '';
  toUpload: number = 0;
  isUploaded: number = 0;
  isUploadCanceled: boolean = false;
  uploadWaitPopupVisible: boolean = false;
  private currentUploadHandle: UploadHandle | null = null;

  constructor(private spinnerService: SpinnerService, private chunkedUploadService: ChunkedUploadService) {
    this.onClickUebernehmen = this.onClickUebernehmen.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
  }

  get canUpload(): boolean {
    return (!this.uploadFiles || !this.uploadFiles.length) || (this.validation(false) === false);
  }

  addFile(event: any) {
    this.uploadFiles = event.value;
  }

  onUploadCancel(e: any) {
    this.isUploadCanceled = true;
    if (this.currentUploadHandle) {
      this.currentUploadHandle.cancel();
      this.currentUploadHandle = null;
    }
  }

  onClickUebernehmen() {

    let isValid = true;
    const errorMsgs: string[] = [];

    for (let index = 0; index < this.uploadFiles.length; index++) {
      const file = this.uploadFiles[index];
      const ext = file.name.split('.').pop();
      if (!this.allowedFileExtensions.find(x => x.endsWith(ext))) {
        errorMsgs.push('Dateitype wird nicht akzeptiert! \'' + file.name + '\'');
        isValid = false;
      }

    }
    if (!isValid) {
      notify({
        contentTemplate: () => {
          let html = '';
          for (let index = 0; index < errorMsgs.length; index++) {
            const errorMsg = errorMsgs[index];
            html += errorMsg + '<br>';
          }

          return $('<div class="dx-toast-message" role="alert"></div>').html(html);
        },
        width: 600
      }, 'error', 3000);
      return;
    }

    if (this.validation()) {
      this.isUploadCanceled = false;
      this.isUploaded = 0;
      this.toUpload = this.uploadFiles.length;
      this.popupVisible = false;
      this.uploadWaitPopupVisible = true;

      const _obj = {
        ownerId: this.uploadContext.ownerId,
        entityArt: this.uploadContext.entityArt,
        bezeichnung: this.uploadContext.bezeichnung,
        docHash: this.uploadContext.docHash
      };

      this._upload(_obj, this.uploadFiles);
    }
  }

  private async _upload(context: any, files: File[]) {
    if (this.isUploadCanceled) {
      this.resetUploadState();
      return;
    }
    if (this.isUploaded === this.toUpload) {
      this.resetUploadState();
      this.onOkClose.emit(true);
      return;
    }

    const file = files[this.isUploaded];
    this.uploadFileName = file.name;

    const lastDate = new Date(file.lastModified);
    lastDate.setHours(lastDate.getHours() + 1);
    context.lastModifiedDate = lastDate;

    try {
      this.currentUploadHandle = this.chunkedUploadService.uploadFile(file, context);
      await this.currentUploadHandle.promise;
      this.currentUploadHandle = null;
      this.isUploaded++;
      await this._upload(context, files);
    } catch (err) {
      if (this.currentUploadHandle) {
        this.currentUploadHandle.cancel();
        this.currentUploadHandle = null;
      }
      if (this.isUploadCanceled) {
        this.resetUploadState();
        return;
      }
      this.stopLoading();
      throw err;
    }
  }

  onClickClose() {
    // this.onClose.emit(null);
    this.popupVisible = false;
  }

  validation(withMsg: boolean = true) {
    const validationResult = this.form.instance.validate();

    if (!validationResult.isValid) {
      if (withMsg) {
        let msg = '';
        for (const err of validationResult.brokenRules) {
          msg += err.message + '\r\n';
        }

        notify({
          message: msg,
          width: 600
        }, 'error', 3000);
      }

      return false;
    }
    else {
      return true;
    }
  }

  onShowingPopup(event: any) {
    this.uploadFiles = null;
    this.isUploadCanceled = false;
  }

  onHiddenPopup(event: any) {
    this.fileUploader.instance.reset();
    this.uploadFileName = '';
    this.uploadFiles = null;
    this.uploadContext = null;
    this.onClose.emit(null);
  }

  private resetUploadState() {
    this.uploadWaitPopupVisible = false;
    this.isUploaded = 0;
    this.toUpload = 0;
    this.uploadFiles = [];
    this.uploadFileName = '';
    this.isUploadCanceled = false;
  }

  private startLoading() {
    this.spinnerService.show();
  }

  private stopLoading() {
    this.spinnerService.hide();
  }
}
